import { IBoostedGifOptions } from "services/types";
import { useNewBoostedGifs } from "hooks/useNewBoostedGifs";

interface IUseWatchBoostedGifs {
  rel?: string;
  gifId: string | null;
}

export const useWatchBoostedGifs = ({ rel, gifId }: IUseWatchBoostedGifs) => {
  const filter: IBoostedGifOptions = {};
  const match = rel?.match(/^(niche|tag):([^,]+)/);

  if (match) {
    filter[match[1] as "niche" | "tag"] = match[2];
  } else {
    filter.gif = gifId;
  }

  return useNewBoostedGifs(filter);
};
